angular.module("modalitaFirmaPostVendita.components", [])
    .component("modalitaFirmaPostVendita", {
        templateUrl: 'ng/components/modalitaFirmaPV/modalitaFirmaPostVendita.view.html',
        bindings: {
            model: '=',
            firmaChanged: '&',
            hideChoiceSignature: '<'
        },
        controller: ModalitaFirmaPostVendita,
        controllerAs: "modalitaFirmaPvCtrl"
    })

function ModalitaFirmaPostVendita() {
    var self = this;

    self.$onInit = function () {

        self.supportModel = {
            firmaAlbaLeasing: {
                selected: false
            }
        }


        self.supportModel.firmaAlbaLeasing.selected = !self.model.firmaDigitaleEsterna;


    }

    self.handleChange = function (tipo, value) {

        if (tipo == 'firmaDigitale') {
            self.model[tipo] = value;
        }

        self.firmaChanged()

    }

    self.check = function (el) {
        el.selected = !el.selected;

        self.model.firmaDigitaleEsterna = !el.selected;
        self.handleChange("firmaEsterna", 'qualsiasi valore'); //controllo aggiunto per far partire la funzione di esportazione del cambiamento firma    
    }

};
